import React, { ReactNode } from 'react';
import { IntlShape } from 'react-intl';

export const dictionary = {
    aria_label_exit_full_screen: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.3c164e4a018c337e6669142de60b2c8e',
            defaultMessage: 'Exit full-screen mode',
            description: 'Aria label for exit full-screen button',
        }),
    aria_label_enter_full_screen: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.e087a1742f0ff13d246fd925639a941b',
            defaultMessage: 'Go to full-screen mode',
            description: 'Aria label for enter full-screen button',
        }),
    aria_label_pause_button: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.105b296a83f9c105355403f3332af50f',
            defaultMessage: 'Pause',
            description: 'Aria label for pause button',
        }),
    aria_label_play_button: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.aria-button-label.1b70a40f4fd377bc0f40cefca8241e70',
            defaultMessage: 'Play now',
            description: 'Aria label for play button',
        }),

    aria_label_backward_seek_button: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.1f643d81104ee2fbbe12867879d95310',
            defaultMessage: '10 seconds back',
            description: 'Aria label for backward seek button',
        }),
    aria_label_close_button: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.2c9f79d160f6891a33556442dd740edc',
            defaultMessage: 'Close player',
            description: 'Ариа описание для кнопки закрытия плеера',
        }),
    seek_button_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.d3d9446802a44259755d38e6d163e820',
            defaultMessage: '10',
            description: 'Text for seek button',
        }),
    aria_label_forward_seek_button: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.b04ba3f82fb62507a20c8d5c71592e55',
            defaultMessage: '10 seconds forward',
            description: 'Aria label for forward seek button',
        }),
    audio_subtitles_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.6dc9c1d2f8378cfa7ad04e2872a1b794',
            defaultMessage: 'Audio and subtitles',
            description: 'Лейбл кнопки "Аудио и субтитры" в плеере',
        }),
    sound_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.9d07e0e08af7f96cf45be0112b9ccfbe',
            defaultMessage: 'Sound',
            description: 'Sound quality label (stereo / 5.1)',
        }),
    audio_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.b22f0418e8ac915eb66f829d262d14a2',
            defaultMessage: 'Audio',
            description: 'Audio track label',
        }),
    sound_quality_stereo_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.PlayerSkin.bbc45d9b35436f5f0ed9e33499efcea9',
            defaultMessage: 'Stereo',
            description: 'Текст для стерео звука в списке озвучек',
        }),
    sound_quality_surround_51_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.PlayerSkin.c7468ad58db810e54e555de2b0b51957',
            defaultMessage: '5.1 surround sound',
            description: 'Текст для 5.1 звука в списке озвучек',
        }),
    sound_quality_other_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.PlayerSkin.6311ae17c1ee52b36e68aaf4ad066387',
            defaultMessage: 'Other',
            description: 'Текст для неизвестного качества звука в списке озвучек',
        }),
    text_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.6a73085e389c48beca8b3f4629b4b1e4',
            defaultMessage: 'Subtitles',
            description: 'Subtitles track label',
        }),
    subtitles_off_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.PlayerSkin.d15305d7a4e34e02489c74a5ef542f36',
            defaultMessage: 'Off',
            description: 'Кнопка отключения субтитров',
        }),
    audio_subtitles_checked_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.91b442d385b54e1418d81adc34871053',
            defaultMessage: 'Selected',
            description: 'Label indicating that track is selected',
        }),
    profiles_movie_announce_page__not_again: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.profiles.ui.profiles-movie-announce-page.55c2eefc919fb18f2b77bc28a029a5c1',
            defaultMessage: 'Do not ask again',
            description: 'Текст кнопки скрытия выбора профиля',
        }),
    profile_subtext__restricted: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.profiles.utils.284f362107a5b9626a0619f51e2b6a85',
            defaultMessage: 'Restricted video',
            description: 'Текст статуса профиля, если включен родительский контроль',
        }),
    profiles_not_loggin: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.user-profile.09b2c7c552d80033cf8e661b7425a777',
            defaultMessage: 'Not logged in',
            description: 'Описание пользовательского профиля для неавторизованного пользователя',
        }),
    profiles_administrator: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.user-profile.7b7bc2512ee1fedcd76bdc68926d4f7b',
            defaultMessage: 'Administrator',
            description: 'Описание пользовательского профиля для администратора',
        }),
    turn_on_sound: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.848b17ca26178e8baeffc6fd69068cfb',
            defaultMessage: 'Turn on sound',
            description: 'Ариа атрибут для кнопки включить звук',
        }),
    turn_off_sound: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.eab5924313a44bcaa4f92de668c21ab1',
            defaultMessage: 'Turn off sound',
            description: 'Ариа атрибут для кнопки выключить звук',
        }),
    default_error_message: (
        intl: IntlShape,
        { div }: { div: (chunks: ReactNode) => JSX.Element }
    ) =>
        intl.formatMessage(
            {
                id: 'features.player.069fd1a242baee05f3e4e273a5a491fc',
                defaultMessage:
                    '<div>Something went wrong on our side.</div><div>Try refreshing.</div>',
                description: 'Текст ошибки по-умолчанию в плеере',
            },
            { div }
        ),
    network_error_message: (
        intl: IntlShape,
        { div }: { div: (chunks: ReactNode) => JSX.Element }
    ) =>
        intl.formatMessage(
            {
                id: 'features.player.0326ecc8f4c5fa67d9aa7eb1372c93a1',
                defaultMessage:
                    "<div>Something's wrong with your internet connection.</div><div>Check your connection and refresh the page.</div>",
                description: 'Network error message on player error screen',
            },
            { div }
        ),
    drm_error_unknown: (intl: IntlShape, { div }: { div: (chunks: ReactNode) => JSX.Element }) =>
        intl.formatMessage(
            {
                id: 'features.player.129752ac48670e23df850dba1e2b4473',
                defaultMessage:
                    "<div>Couldn't play the video</div><div>Contact support —</div><div>we'll sort everything out</div>",
                description: 'DRM error unknown message on player error screen',
            },
            { div }
        ),
    drm_error_unsupported: (
        intl: IntlShape,
        { div }: { div: (chunks: ReactNode) => JSX.Element }
    ) =>
        intl.formatMessage(
            {
                id: 'features.player.3a74be0bc7d30121632f83ed219c2415',
                defaultMessage:
                    '<div>Video playback</div><div>is unavailable. The device</div><div>is not supported</div>',
                description: 'DRM error unknown message on player error screen',
            },
            { div }
        ),
    regional_error_message: (
        intl: IntlShape,
        { div }: { div: (chunks: ReactNode) => JSX.Element }
    ) =>
        intl.formatMessage(
            {
                id: 'features.player.af48e0afb83f3b62d61537014579d624',
                defaultMessage:
                    "<div>You can't watch it in your region</div><div> or you need to </div><div>turn off VPN</div>",
                description: 'Regional error message on player error screen',
            },
            { div }
        ),
    too_many_concurrent_streams_error_message: (
        intl: IntlShape,
        {
            div,
            br,
            brandName,
        }: {
            div: (chunks: ReactNode) => JSX.Element;
            br: (chunks: ReactNode) => JSX.Element;
            brandName: string;
        }
    ) =>
        intl.formatMessage(
            {
                id: 'features.player.27554bb78111a80ddf7d7c0749e452d4',
                defaultMessage:
                    '<div>Someone is already using this account{br}to watch {brandName}</div><div>To start watching, just close the app{br}on the other device</div>',
                description: 'Too many concurrent streams error message on player error screen',
            },
            { div, br, brandName }
        ),
    useful_for_support: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.f7803f2c7d2f0e625f95b9202fca01fd',
            defaultMessage: 'This information will be useful for support',
            description: 'Hint about support data (player error screen)',
        }),
    error_code: (intl: IntlShape, { errorCode }: { errorCode: string }) =>
        intl.formatMessage(
            {
                id: 'features.player.ebe5b5b3d5c53c80cc13b36c5fe63b86',
                defaultMessage: 'Error code: {errorCode}',
                description: 'Error info on player error screen',
            },
            { errorCode }
        ),
    vsid_session_text: (intl: IntlShape, { vsid }: { vsid: string }) =>
        intl.formatMessage(
            {
                id: 'features.player.50434a46176a9aefa2c78a0be66271f0',
                defaultMessage: '<span>Session VSID:</span><span>{vsid}</span>',
                description: 'VSID session text on player error screen',
            },
            { vsid, span: (chunks: ReactNode) => <span>{chunks}</span> }
        ),
    refresh_button_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.63a6a88c066880c5ac42394a22803ca6',
            defaultMessage: 'Refresh',
            description: 'Refresh button text on player error screen',
        }),
    support_button_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.ad119d5ea30f6c26b58e0af5bc43c9fe',
            defaultMessage: 'Contact support',
            description: 'Support button text on player error screen',
        }),
    settings_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.f4f70727dc34561dfde1a3c529b6205c',
            defaultMessage: 'Settings',
            description: 'Settings label (player skin)',
        }),
    subtitles_size_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.3a9dd5e1d7c003ba046106646aa40aa4',
            defaultMessage: 'Subtitle size',
            description: 'Subtitle size label',
        }),
    subtitles_size_small_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.afc493b6574d5529ed0ffa6f18f05b20',
            defaultMessage: 'Smaller',
            description: 'Subtitle size small label',
        }),
    subtitles_size_medium_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.eb6d8ae6f20283755b339c0dc273988b',
            defaultMessage: 'Standard',
            description: 'Subtitle size medium label',
        }),
    subtitles_size_large_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.f36c7e211f1636f324981b1d020c1475',
            defaultMessage: 'Larger',
            description: 'Subtitle size large label',
        }),
    settings_auto_quality_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.PlayerSkin.06b9281e396db002010bde1de57262eb',
            defaultMessage: 'Auto',
            description: 'Настройка "Авто" в настройках плеера',
        }),
    settings_quality_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.571094bb27864b600d8e6b561a137a55',
            defaultMessage: 'Quality',
            description: 'Settings quality label',
        }),
    settings_rate_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.44877c6aa8e93fa5a91c9361211464fb',
            defaultMessage: 'Speed',
            description: 'Settings rate label',
        }),
    settings_normal_rate_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.960b44c579bc2f6818d2daaf9e4c16f0',
            defaultMessage: 'Normal',
            description: 'Settings normal rate label',
        }),
    skip_preroll: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.72ef2b9b6965d078e3c7f95487a82d1c',
            defaultMessage: 'Skip',
            description: 'Текст по умолчанию для группы кнопок для пропуска титров и пр в плеере',
        }),
    skip_dismiss_preroll: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.369c97846792fb1b579409e88c881182',
            defaultMessage: 'Watch now',
            description:
                'Текст по умолчанию для группы кнопок для того, чтобы оставить титры и тд в плеере',
        }),
    skip_intro: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.72ef2b9b6965d078e3c7f95487a82d1c',
            defaultMessage: 'Skip',
            description: 'Текст по умолчанию для группы кнопок для пропуска титров и пр в плеере',
        }),
    skip_dismiss_intro: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.3c030a04cd8f2130b3d3f45d878f2f07',
            defaultMessage: 'View intro',
            description: 'Текст кнопки оставить заставку в секции кнопок в скине плеера',
        }),
    skip_recap: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.72ef2b9b6965d078e3c7f95487a82d1c',
            defaultMessage: 'Skip',
            description: 'Текст по умолчанию для группы кнопок для пропуска титров и пр в плеере',
        }),
    skip_dismiss_recap: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.c00cfed67a57caf97cb6ee73201b0a04',
            defaultMessage: 'Watch recap',
            description: 'Текст для просмотра повтора в группе кнопок в плеере',
        }),
    skip_credits: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.72ef2b9b6965d078e3c7f95487a82d1c',
            defaultMessage: 'Skip',
            description: 'Текст по умолчанию для группы кнопок для пропуска титров и пр в плеере',
        }),
    skip_dismiss_credits: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.2356e5f7f801f88158bdbec7b67a1e68',
            defaultMessage: 'View credits',
            description: 'Текст в группе кнопок в конце сериала для просмотра титров',
        }),
    skip_next_episode: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.f13c30cf44b49bfd339d433f89bb5bcd',
            defaultMessage: 'Next episode',
            description:
                'Текст в группке кнопок в конце сериала для переключения на следующую серию',
        }),
    episode_subtitle_with_title: (
        intl: IntlShape,
        {
            seasonNumber,
            seriesNumber,
            finalTitle,
        }: { seasonNumber: number; seriesNumber: number; finalTitle: string }
    ) =>
        intl.formatMessage(
            {
                id: 'features.episode-player.b89d38382a22a4643605a234109a6a3a',
                defaultMessage: 'Season {seasonNumber}, episode {seriesNumber}. {finalTitle}',
                description: 'Мета для тв шоу c финальным заголовоком',
            },
            { seasonNumber, seriesNumber, finalTitle }
        ),
    seasons_and_episodes_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.9d25fa6be48dcf0506d75825b3152c4e',
            defaultMessage: 'Seasons and episodes',
            description: 'Кнопка сезоны и серии в попапе навигации плеера для сериалов',
        }),
    episode_subtitle_without_title: (
        intl: IntlShape,
        { seasonNumber, seriesNumber }: { seasonNumber: number; seriesNumber: number }
    ) =>
        intl.formatMessage(
            {
                id: 'features.episode-player.225d3005c7b03fb249de8912bb6810ae',
                defaultMessage: 'Season {seasonNumber}, episode {seriesNumber}.',
                description: 'Мета для тв шоу',
            },
            { seasonNumber, seriesNumber }
        ),
    aria_label_next_episode_button: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.player.09ae1555da2b68862f3842de422ad585',
            defaultMessage: 'Go to the next episode',
            description: 'Ариа атрибут для кнопки перехода к следующему эпизоду',
        }),
    smoking_warning_film: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.PlayerSkin.6ad454c30bb441a018d8baf28f2a1676',
            defaultMessage: 'This movie contains smoking scenes. Smoking kills.',
            description: 'Предупреждение о курении в фильме',
        }),
    smoking_warning_episode: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.PlayerSkin.75aeda4f65935fad87fd2792d561bd3a',
            defaultMessage: 'This TV series contains smoking scenes. Smoking kills.',
            description: 'Предупреждение о курении в сериале',
        }),
};
